import CategoryTag, { categoryTagColors } from "@/domain/enums/CategoryTag";
import { lighten } from "polished";
import { useTranslation } from "react-i18next";
import { Badge } from "../ui/badge";

type CategoryBadgeProps = {
    category: CategoryTag;
};

const FALLBACK_CATEGORY_COLOR = "#6B7280";

const CategoryBadge = ({ category }: CategoryBadgeProps) => {
    const color = categoryTagColors[category] ?? FALLBACK_CATEGORY_COLOR;
    const lightenedColor = lighten(0.55, color);
    const { t } = useTranslation();

    return (
        <Badge
            className="shrink-0 capitalize whitespace-nowrap"
            style={{
                color,
                backgroundColor: lightenedColor,
            }}
        >
            {`#${t(`categories.${category}`)}`}
        </Badge>
    );
};

export default CategoryBadge;
